import {createContext, useReducer} from "react"
import loginReducer from "src/loginReducer";
import { ACCOUNT_DETAILS } from "src/types";
import React from "react";

export const LoginContext = createContext({})

const LoginContextProvider = ({children}) => {

    const initialState = {
        recaptchaSiteKey: '',
        captchaToken: '',
        accountDetails: {
          phoneNumber: '',
          verificationId: '',
          fullName: '',
          emailId: '',
          newUser: false,
          ivrInfo: null,
          mfaInfo: null,
          passwordInfo: null,
          showLink: false,
          otp: '',
          ssid: '',
          captchaToken: '',
        },
        countryList: [],
        selectedCountry: {
          countryName: 'INDIA',
          dialingCode: '+91',
          countryFlag: 'https://olawebcdn.com/sso_images/v1/in.svg',
          countryCode: 'IN',
          maxNumberLength: '10',
          minNumberLength: '10',
          startingDigits: [9],
        },
        isLoggedIn: false,
        isReserveCtaClicked: false,
      };
      const [state, dispatch] = useReducer(loginReducer, initialState);

      const setAccountDetails = (data) => {
        console.log("dispatched ACCOUNT_DETAILS with data", data)
        dispatch({
          type: ACCOUNT_DETAILS,
          payload: { res: data },
        });
      };

      return (
        <LoginContext.Provider
          value={{
            state,
            dispatch: {
              setAccountDetails
            },
          }}
        >
          {children}
        </LoginContext.Provider>
      );
}

export default LoginContextProvider;